import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@monorepo-channels/shared/util-environments'
import { Order } from '../../../control-panel.service'

@Injectable({
	providedIn: 'root',
})
export class ConciergeCancelReservationService {
	private baseUrl = `${environment.channelsAPIURL}/api/v1/orders`
	private http = inject(HttpClient)

	constructor() {}

	cancelReservation(orderId: string): Observable<Order> {
		return this.http.delete<Order>(`${this.baseUrl}/admin/${orderId}`)
	}
}
